export const USER_ROLE = 'USER'
